import React from "react";

import { BrowserRouter, Routes, Route } from "react-router";
import Login from "../pages/Login";
import Home from "../pages/Home";
import Eligibility from "../pages/Eligibility";
import UserEligibility from "../pages/UserEligibility";


const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/home" element={<Home />} />
                <Route path="/eligibility/:id" element={<Eligibility />} />
                <Route path="/user/eligibility/:id" element={<UserEligibility />} />
            </Routes>
        </BrowserRouter>
    )
}

export default AppRouter;